/**
 * Auth token storage helpers.
 *
 * Uses the same localStorage keys as the legacy mock services to allow seamless
 * migration between mock and real API sessions.
 */

const STORAGE_KEYS = {
  ACCESS_TOKEN: 'pg_pharma_token',
  REFRESH_TOKEN: 'pg_pharma_refresh_token',
  EXPIRES_AT: 'pg_pharma_expires_at',
} as const

export function getAccessToken(): string | null {
  return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN)
}

export function getExpiresAt(): Date | null {
  const raw = localStorage.getItem(STORAGE_KEYS.EXPIRES_AT)
  if (!raw) return null
  const date = new Date(raw)
  return Number.isNaN(date.getTime()) ? null : date
}

export function setAuthTokens(input: {
  accessToken: string
  refreshToken?: string | null
  expiresAt?: Date | string | null
}): void {
  localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, input.accessToken)

  if (input.refreshToken) {
    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, input.refreshToken)
  } else {
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
  }

  const expiresAt =
    typeof input.expiresAt === 'string'
      ? new Date(input.expiresAt)
      : input.expiresAt ?? null

  if (expiresAt && !Number.isNaN(expiresAt.getTime())) {
    localStorage.setItem(STORAGE_KEYS.EXPIRES_AT, expiresAt.toISOString())
  } else {
    localStorage.removeItem(STORAGE_KEYS.EXPIRES_AT)
  }
}

export function clearAuthTokens(): void {
  localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN)
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
  localStorage.removeItem(STORAGE_KEYS.EXPIRES_AT)
}

